






























































































import Vue from 'vue'
import { DataTreeNode } from '@/utils/array'
import { getUserInfo } from '@/utils/auth'
import {
  WorkStationGroupServiceProxy
} from "@/service-proxies/app-v2/workStation.service-proxies";
import { ShiftServiceProxy } from '@/service-proxies/app-v2/time.service-proxies'
import { TenantSettingServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import dayjs from 'dayjs';
import moment from 'moment';
const ssp = new ShiftServiceProxy()
const wsgsp = new WorkStationGroupServiceProxy()
const tssp = new TenantSettingServiceProxy()

export default Vue.extend({
  name: "left-tree",
  props:['queryKey'],
  data(){
    return{
      filter: {
        date: '',
        shiftIndex: '',
        workStationId: ''
      },
      statisticalMethod: 'DAY',
      checkShift: '',
      rangeData: '',
      selectedKeys: [],
      expendKeys: [],
      treeData: [],
      workStatoinItems: [],
      shiftIndexs: [],
      cilentHeight: '260px',
      recordId:'',
      saveIndex:0
    }
  },
  created(){
    console.log(this.queryKey)
    this.rangeData = dayjs().format('YYYY-MM-DD')
    this.treeData = []
    this.getShift()
  },
  updated(){
    this.getCilentHeight()
  },
  methods:{
    moment,
    getCilentHeight(){
      const cilent = document.getElementById('leftTreeSelect')
      this.cilentHeight = cilent.clientHeight + 70 + 'px'
    },
    getShift(){
      this.shiftIndexs = []
      this.checkShift = ''
      ssp.getShiftIndexName().then(res =>{
        if(res.keyNameDTOList && res.keyNameDTOList.length > 0){
          this.shiftIndexs = res.keyNameDTOList
          this.checkShift = res.keyNameDTOList[0].key
        }
        this.getTreeList()
      })
    },
    expandKey(value){
      this.expendKeys = value
    },
    async getTreeList(){
      this.workStatoinItems = []
      this.expendKeys = []
      this.selectedKeys = []
      const userId = this.getUserId()
      let tracList = []
      let result = await tssp.detailConditions(userId,this.queryKey,'','','','')
      if(result.length>0){
        this.recordId = result[0].id
        tracList = JSON.parse(result[0].paramValue)
      }
      
      wsgsp.workStationGroupList().then(res =>{
        if(res){
          const data = res.reduce((total, value) =>{
            const key = value.id + '-' + value.parentId
            let selectable = false
            if(value.isWorkStation){
              selectable = true
            }
            total.push({
              ...value,
              key: key,
              selectable: selectable
              })
              if(value.isWorkStation && !this.selectedKeys.length){
                console.log(key)
                this.selectedKeys.push(key)
              } else if(value.isGroup){
                this.expendKeys.push(key)
              }
            return total
          }, [])
          if(tracList.length>0){
            this.selectedKeys = tracList
          }
          this.treeData = DataTreeNode.arrayToTree(data);
          

          let copy = this.treeData
          copy.forEach((x) => {
            x.scopedSlots = {
              title: 'custom'
            }
            x.name = x.title;
            if(x.children) {
              x.children.forEach((y) => {
                y.scopedSlots = {
                  title: 'custom'
                }
                y.name = y.title;  
                if(y.children) {
                  y.children.forEach((z) => {
                    z.scopedSlots = {
                      title: 'custom'
                    }
                    z.name = z.title;
                    if(z.children) {
                      z.children.forEach((a) => {
                        a.scopedSlots = {
                          title: 'custom'
                        }
                        a.name = a.title;
                      })
                    }
                  })
                }
              })
            }
          })
          this.treeData = copy


          this.workStatoinItems = data
          this.handelSearch()
        }
      })
    },
    addKeyId(item){
      const key = item.id + '-' + item.parentId
      return key
    },
    
    setWorkStationList(){
      let key = ''
      this.workStatoinItems.map(res =>{
        if(this.selectedKeys.includes(this.addKeyId(res)) && !res.isGroup){
          key = res.id
        }
      })
      return key
    },

    setWorkStationName(){
      let name = ''
      this.workStatoinItems.map(res =>{
        if(this.selectedKeys.includes(this.addKeyId(res)) && !res.isGroup){
          name = res.title
        }
      })
      return name
    },

    handelSearch(){
      if(this.statisticalMethod === 'SHIFT'){
        this.filter.shiftIndex = this.checkShift
      } else {
        this.filter.shiftIndex = undefined
      }
      this.filter.date = dayjs(this.rangeData).format('YYYY-MM-DD')
      const workstationName = this.setWorkStationName()
      this.filter.workStationId = this.setWorkStationList()
      if(this.selectedKeys.length < 1){
        this.$message.warning(this.$t('page_time_analysis_selectworkstation'))
        return
      }
      if(this.filter.statisticalMethod === 'SHIFT' && this.filter.shiftList < 1){
        this.$message.warning('请选择班次')
        return
      }
      console.log(this.saveIndex)
      if(this.saveIndex>0){
        this.saveSelectInfo()
      }
      this.saveIndex = this.saveIndex + 1
      this.$emit('search',this.filter,workstationName)
    },

    hanldeOutPut(){
      this.$emit('outPut')
    },

    selectStatisticalMethod(value){
      this.getCilentHeight()
      this.statisticalMethod = value
    },

    selectShiftIndexs(value){
      this.checkShift = value.target.value
    },

    rangeChange(value){
      if(!value){
        this.rangeData = dayjs().format('YYYY-MM-DD')
      } else {
        this.rangeData = value
      }
    },

    onSelect(value){
      console.log(value)
      this.selectedKeys = value
    },
    async saveSelectInfo(){
      const userId = this.getUserId()
      let arr = []
      this.workStatoinItems.map(res=>{
        if (
          this.selectedKeys.includes(this.addKeyId(res)) &&!res.isGroup
        ){
          arr.push(res.id + '-' + res.parentId)
        }
      })
      const body:any = {
        paramName:this.queryKey,
        paramKey:userId,
        paramValue:JSON.stringify(arr),
        id:this.recordId
      }
      await tssp.submit(body)
    },
    getUserId() {
      const info = getUserInfo()
      return info.user_id || ''
    },
  }
})
